// various data/flags for various purposes... wrapped as "arbitrary" domain object for convenience
import { domainAction } from './domain-redux';
/**
 * @param dispatch
 * @param isAgent
 */
export var dispatchOppositeParty = function (dispatch, isAgent) {
    dispatch(domainAction.setDomainOppositeParty(isAgent));
};
